export const generatingMicroreelText = {
  allMicroreels: 'All microreels',
  generating: 'Generating',
  generatingYourReels: 'Generating your reels',
  generatingHint1: 'About 3 minutes left.',
  generatingHint2: "You can leave this page, we'll notify you",
  stepContentAnalyzed: 'Content analyzed',
  stepScriptWritten: 'Script written',
  stepRenderingScenes: 'Rendering scenes',
  stepAddingNarration: 'Adding narration',
  long: 'long',
  vertical: 'Vertical',
  voice: 'Voice',
  narration: 'narration',
  source: 'Source',
  excludedPages: 'Excluded pages:',
  credits: 'credits',
  pages: 'pages',
  settingsUsed: 'Settings used',
  labelLength: 'Length per reel',
  valueLength: '30–60 sec',
  hintLength: 'Target duration for every reel',
  labelLanguage: 'Language',
  valueLanguage: 'English (US)',
  hintLanguage: 'Narration and on-screen text',
  labelVoice: 'Voice',
  valueVoice: 'Emma — female',
  hintVoice: 'Warm, clear AI narration',
  labelVisuals: 'Visuals',
  valueVisuals: 'Stock library',
  hintVisuals: 'Licensed Storyblocks media',
  labelDetailLevel: 'Detail level',
  hintDetailLevel: 'Balanced explanation of the source',
  labelCredits: 'Credits',
  hintCredits: 'Estimated for this generation',
  fallbackTitle: 'Generating microreels',
  generationFailed:
    'The generation could not be completed — no new microreels were created.',
  checkFailed: "Can't reach the server to check on this generation.",
  checkFailedRetry: 'Check again',
  cancelGeneration: 'Cancel generation',
  cancelConfirm:
    'Cancel generating microreels? Every generation still in progress will be discarded and the credits already spent may not be refunded.',
  cancelConfirmAccept: 'Cancel generation',
};
